import { FlexboxProps, LayoutProps } from "styled-system";
import Box from "../Box";
import { COLORS } from "../../utils/colors";

type ProgressBarProps = {
  target: number;
  value: number;
  bg?: string;
} & LayoutProps &
  FlexboxProps;

const ProgressBar = ({ target, value, bg = "#E5E9F0", ...rest }: ProgressBarProps) => {
  const progress = (value / target) * 100;
  const diff = value - target;
  return (
    <Box bg={bg} borderRadius={1} display="flex" width={"100%"} {...rest}>
      <Box
        data-testid={"progressbar"}
        bg={diff >= 0 ? COLORS.green : COLORS.red}
        borderRadius={1}
        p={"4px"}
        display="flex"
        width={`${progress}%`}
      ></Box>
    </Box>
  );
};

export default ProgressBar;
